var _effectorFileName = "/src/page-content/home/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { Main } from '@/page-content/home/components/main';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { ForWhomOurLessons } from '@/widgets/layouts/main/for-whom-our-lessons';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { HowWeWork } from './components/how-we-work';
import { LessonsExamples } from './components/lessons-examples';
import { Numbers } from './components/numbers';
import { OurOffers } from './components/our-offers';
import { Partners } from './components/partners';
import { PlusesWorkWithUs } from './components/pluses-work-with-us';
import { AboutTeam } from './components/team/about-team';
export const HomePage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="" description="Enlerno – English language for professional communication and success on international scene." />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${process.env.NEXT_PUBLIC_APP_NAME} - English for companies`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description="Enlerno – English language for professional communication and success on international scene." about={['enlerno', 'english', 'online', 'english for companies', 'corporate english']} />

      <Main />

      <ForWhomOurLessons />

      <Numbers />

      <Partners />

      <PlusesWorkWithUs />

      <OurOffers />

      <AboutTeam />

      <HowWeWork />

      <LessonsExamples />

      <Reviews />

      <CallToAction header="Contact Us" description="And we will help your employees become confident in English" />
    </>;
};
HomePage.Layout = MainLayout;